import { useState } from 'react';
import Button from 'react-bootstrap/Button';
import Offcanvas from 'react-bootstrap/Offcanvas';

function Signup({ name, pack, ...props }) {
    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    return(
    <>
      <Button className="btn-outline-light"variant="danger" size='sm' onClick={handleShow} >
        Select
      </Button>
      <Offcanvas show={show} onHide={handleClose} {...props}   style={{width: "75vw", backgroundColor:"black", border:"2px solid", borderColor:"#D33D3D"}}>
        <Offcanvas.Header className='btn-close-white' closeButton style={{color:"white", backgroundColor:"black"}}>
          <Offcanvas.Title style={{color:"white"}}>{name}</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body style={{margin:"-2px",padding:"0px", backgroundColor:"black", overflow:"hidden", border:"2px solid", borderColor:"#D33D3D", justifyContent:"center"}}>
          <iframe title="pt" src={pack} style={{width:"75vw", height:"100%", backgroundColor:"black", border:"2px solid", borderColor:"#D33D3D"}}></iframe>
        </Offcanvas.Body>
      </Offcanvas>
    </>
            
            
        
    );
}

export default Signup;